import React from 'react';

import classes from './Toolbar.css';
import Logo from '../UI/Logo/Logo';

const toolbar = (props) => {
  let user = sessionStorage.getItem('userId');
  let logoCss = false;
  if((sessionStorage.getItem('accountNumber') === undefined ||  sessionStorage.getItem('accountNumber') === 'undefined')
   && (sessionStorage.getItem('mac') === null || sessionStorage.getItem('mac') === 'null')){
    logoCss = true;
  }
  return (
    <header className={classes.Toolbar}>
     <div className={props.showLogo ? logoCss ? classes.ToolbarLogo : classes.Logo : classes.hideLogo}>
        <Logo/>
      </div>
      <div className={classes.User}>
        {user}
      </div>
    </header>
  );
}

export default toolbar;
